// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__2WQyk","col":"styles_col__3ufBy"};